import { Link } from 'react-router-dom';

const SERVICES = [
  { to: '/client/services', label: 'GST Registration' },
  { to: '/client/services', label: 'Company Incorporation' },
  { to: '/client/services', label: 'Trademark Registration' },
  { to: '/client/services', label: 'Income Tax Services' },
  { to: '/client/services', label: 'Business Licenses' },
  { to: '/client/services', label: 'All Services' },
];

const COMPANY = [
  { href: '#why', label: 'Why EcRegi' },
  { href: '#how', label: 'How It Works' },
  { href: '#benefits', label: 'Benefits' },
  { href: '#faq', label: 'FAQ' },
];

const LEGAL = [
  { href: '/terms.pdf', label: 'Terms of Service' },
  { href: '/privacy.pdf', label: 'Privacy Policy' },
  { href: 'mailto:support@ecregi.com', label: 'Contact' },
];

export function LandingFooter() {
  return (
    <footer className="border-t border-emerald-100/80 bg-[#f0f9f4] text-gray-700">
      <div className="mx-auto grid w-full max-w-7xl 2xl:max-w-[1400px] grid-cols-1 gap-10 px-4 sm:px-6 lg:px-8 py-14 sm:grid-cols-2 md:grid-cols-5">
        <div className="md:col-span-2">
          <Link to="/" className="inline-flex items-center gap-2">
            <img src="/ecregi_logo.png" alt="EcRegi" className="h-8 w-8" />
            <span className="text-lg font-bold text-brand-700 tracking-tight">ECREGI</span>
          </Link>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-gray-600">
            Registrations, filings and compliance — handled with trust.
          </p>
          <div className="mt-5 flex items-center gap-4 text-gray-500">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              className="rounded-md p-1.5 hover:bg-emerald-100/60 hover:text-[#15803d] transition-colors"
            >
              <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
              </svg>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Twitter"
              className="rounded-md p-1.5 hover:bg-emerald-100/60 hover:text-[#15803d] transition-colors"
            >
              <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.05c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z" />
              </svg>
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
              className="rounded-md p-1.5 hover:bg-emerald-100/60 hover:text-[#15803d] transition-colors"
            >
              <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
          </div>
        </div>

        <FooterCol title="Services" items={SERVICES} />
        <FooterCol title="Company" items={COMPANY} />
        <FooterCol title="Legal" items={LEGAL} />
      </div>

      <div className="border-t border-emerald-100/70">
        <div className="mx-auto flex w-full max-w-7xl 2xl:max-w-[1400px] flex-col items-center justify-between gap-3 px-4 sm:px-6 lg:px-8 py-5 text-xs text-gray-600 sm:flex-row">
          <span>
            © {new Date().getFullYear()} EcRegi Services Private Limited. All rights reserved.
          </span>
          <a
            href="mailto:support@ecregi.com"
            className="underline underline-offset-2 hover:text-[#15803d]"
          >
            support@ecregi.com
          </a>
        </div>
      </div>
    </footer>
  );
}

type Item = { label: string; to?: string; href?: string };

function FooterCol({ title, items }: { title: string; items: Item[] }) {
  return (
    <div>
      <h4 className="text-sm font-semibold text-gray-900">{title}</h4>
      <ul className="mt-3.5 space-y-2.5 text-xs sm:text-sm">
        {items.map((item) => (
          <li key={item.label}>
            {item.to ? (
              <Link to={item.to} className="text-gray-600 hover:text-brand-700 transition-colors">
                {item.label}
              </Link>
            ) : (
              <a href={item.href} className="text-gray-600 hover:text-brand-700 transition-colors">
                {item.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
